// @workflow tasks.show-in-3d
/**
 * A facility deep link that names several tags (`tagIds`, utils/tagDeepLink.js) isolates them
 * through the one "isolate these tags" path: the UI action `ui.viewer.focus_tags` (prepare the 3D
 * model, then the viewer adapter's scene), run by the same runner as the assistant and its
 * buttons. The runner is loaded on demand, so the facility page's import graph does not grow.
 */
import { UI_TOOL } from '@Assistant/domain/uiToolContract';
import { FOCUS_MODE } from '@Assistant/domain/viewerContract';

const loadRunner = () => import('@Assistant/services/uiActionRunner');

/**
 * @param {{ store: import('vuex').Store, router: import('vue-router').default, runnerModule?: () => Promise<object> }} ctx
 *        `runnerModule` loads the runner module (injectable for tests)
 * @param {string[]} tagIds the link's tags (tagIdsFromQuery)
 * @returns {Promise<{ ok: boolean, data?: object, error?: string, detail?: string }>} the action's answer
 */
export async function isolateLinkedTags({ store, router, runnerModule = loadRunner }, tagIds) {
  const { uiActionRunner } = await runnerModule();
  return uiActionRunner(store, router).runAction({ name: UI_TOOL.VIEWER_FOCUS_TAGS, args: { tagIds, mode: FOCUS_MODE.ISOLATE } });
}
